import { css } from '@emotion/react'
import type { Theme } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const wrapper = (theme: Theme) => css`
  border-width: 1px;
  border-style: dashed;
  padding: ${size[16]} ${size[24]};
  border-radius: ${size[4]};
  margin-bottom: ${size[20]};
  display: flex;
  flex-direction: column;
  gap: ${size[12]};

  ${breakpoint.up('md')} {
    margin-bottom: ${size[24]};
  }

  a {
    color: ${theme.palette.primary.mainContrast};
    text-decoration: none;
    font-weight: 500;
  }
`

export const colors = {
  danger: (theme: Theme) => css`
    border-color: ${theme.palette.error.main};
    background-color: ${theme.palette.error.lowContrast};
  `,
  warning: (theme: Theme) => css`
    border-color: ${theme.palette.warning.main};
    background-color: ${theme.palette.warning.lowContrast};
  `,
  primary: (theme: Theme) => css`
    border-color: ${theme.palette.success.main};
    background-color: ${theme.palette.success.lowContrast};
  `,
  neutral: (theme: Theme) => css`
    border-color: ${theme.palette.ghost.mediumContrast};
    background-color: ${theme.palette.background.accent};
  `,
}
